import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type ExerciseQuestionsFragment = { id: string, text: string, responseType: Types.ResourceResponseTypeEnum, medias?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, imageHotspots?: Array<{ mediaId: string, hotspots: Array<{ id: string, x: number, y: number }> }> | null, customRatingComponent?: { ratingLabels: Array<{ labelName: string, rating?: number | null }> } | null };


export type ExerciseQuestionsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ExerciseQuestionsFragmentDoc = /*#__PURE__*/ gql`
    fragment ExerciseQuestions on ExerciseQuestionType {
  id
  text
  responseType
  medias {
    ...EntityMedia
  }
  imageHotspots {
    hotspots {
      id
      x
      y
    }
    mediaId
  }
  customRatingComponent {
    ratingLabels {
      labelName
      rating
    }
  }
}
    `;